import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import { useColor } from '~/global/hooks/useColor';
import { useTranslation } from 'react-i18next';
import { FitnessGoal } from '~/graphql/generated/graphql';
import type { IconProps } from '~/global/components/icon/Icon';

const GOAL_OPTIONS: {
  value: FitnessGoal;
  icon: IconProps['name'];
}[] = [
  { value: FitnessGoal.GainWeight, icon: 'TrendingUp' },
  { value: FitnessGoal.LoseWeight, icon: 'TrendingDown' },
  { value: FitnessGoal.StayFit, icon: 'Activity' },
];

export interface FitnessGoalSelectorProps {
  selected: FitnessGoal | null | undefined;
  onSelect: (goal: FitnessGoal) => void;
}

export const FitnessGoalSelector = ({
  selected,
  onSelect,
}: FitnessGoalSelectorProps) => {
  const { t } = useTranslation('user');
  const accentColor = useColor('accent');
  const mutedColor = useColor('text-muted');

  return (
    <View className="flex flex-col xl:flex-row gap-2 xl:gap-3">
      {GOAL_OPTIONS.map(({ value, icon }) => {
        const isActive = selected === value;
        return (
          <Pressable
            key={value}
            onPress={() => onSelect(value)}
            className={`flex-row xl:flex-col xl:flex-1 items-center justify-between xl:justify-center gap-3 rounded-xl xl:rounded-xl p-3.5 xl:py-5 xl:px-6 border ${
              isActive
                ? 'bg-accent-soft border-accent'
                : 'bg-surface-elevated border-transparent'
            }`}
          >
            <View className="flex-row xl:flex-col items-center gap-3 xl:gap-2">
              <Icon
                name={icon}
                size={20}
                color={isActive ? accentColor : mutedColor}
              />
              <Text
                className={`text-sm font-medium ${
                  isActive ? 'text-foreground' : 'text-foreground'
                }`}
              >
                {t(`settings.fitnessGoal.${value}`)}
              </Text>
            </View>
            <View className="xl:hidden">
              <View
                className={`h-5 w-5 rounded-full border-2 items-center justify-center ${
                  isActive ? 'bg-accent border-accent' : 'border-text-muted'
                }`}
              >
                {isActive && (
                  <View className="h-2 w-2 rounded-full bg-background" />
                )}
              </View>
            </View>
          </Pressable>
        );
      })}
    </View>
  );
};
